import { flattenDeep, isArray } from 'lodash';

export const validateSurfacePendingPainting = [
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.surfacePrep';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.cleaningMethod';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.aveSurfaceProfile';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.abrasiveType';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.abrasiveSieveSize';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.pressureUsed';
    }
  },
];

export const validateExecutionPendingPainting = [
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintProduct`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintBatchNumberPathA`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintBatchNumberPathB`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.equipmentUsed`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.averageWFT`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.averageDFT`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.weather`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.relativeHumidity`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.dewPoint`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.dryBulbTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.wetBulbTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.substrateTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.workLeaderName`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintingCompletion`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.inspectedByName`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.inspectionDateAndTime`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.remarks`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.attachments`;
    }
  },
];

export const validateProposalPendingPainting = [
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime ===
      data?.submitQAQCsTime?.needToSubmittedTime - 1
    ) {
      return 'proposalBillingDetail.poNumber';
    }
  },
  (data: any) => {
    return getFieldsValidateReinstatements(data);
  },
];

export const validateSurfaceQaqc = [
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.surfacePrep';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.cleaningMethod';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.aveSurfaceProfile';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.abrasiveType';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.abrasiveSieveSize';
    }
  },
  (data: any) => {
    if (data?.submitQAQCsTime?.submittedTime === 0) {
      return 'qaqcInfo.listQAQCDetail[0].surfacePrep.pressureUsed';
    }
  },
];

export const getFieldsValidateReinstatements = (data: any) => {
  const proposalBillingDetail = isArray(data?.proposalBillingDetail?.data)
    ? data?.proposalBillingDetail?.data
    : [];
  const results: string[] = proposalBillingDetail?.map((u: any, i: any) => [
    `proposalBillingDetail.data[${i}].finalMeasurement`,
    `proposalBillingDetail.data[${i}].finalCost`,
  ]);
  return flattenDeep(results);
};

export const validateExecutionQaqc = [
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintProduct`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintBatchNumberPathA`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintBatchNumberPathB`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.equipmentUsed`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.averageWFT`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.averageDFT`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.weather`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.relativeHumidity`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.dewPoint`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.dryBulbTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.wetBulbTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.substrateTemperature`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.workLeaderName`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.paintingCompletion`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.inspectedByName`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.inspectionDateAndTime`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.remarks`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.witnessByName`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.date`;
    }
  },
  (data: any) => {
    if (
      data?.submitQAQCsTime?.submittedTime !==
      data?.submitQAQCsTime?.needToSubmittedTime
    ) {
      return `qaqcInfo.listQAQCDetail[${data?.submitQAQCsTime?.submittedTime}].paintingConditionExecution.attachments`;
    }
  },
];
